import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import DateFormated from "../Utils/Date/Date";
import SelectWrapper from "../Utils/Input/SelectWrapper";
import DatePicker from "react-datepicker";
import formatDate from "../Utils/Date/formatDate";
import {TODAY, TODAY_MINUS_30} from "../Accounts/Account/Tables/DateFilters";
import fr from 'date-fns/locale/fr-CA';
import {Link} from "react-router-dom";
import DownloadButton from "../UI/DownloadButton";

const ModalConsumptionReport = props => {
	const {t, i18n} = useTranslation();
	const [mode, setMode] = useState(null);
	const [selectedPeriod, setSelectedPeriod] = useState('');
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const {subAccountName, subAccountCode, representative, accountCode, numberOfCards, lastUpdate} = props.subAccount;

	function convertLocalToUTCDate(date) {
		if (!date) {
			return date
		}

		return date
	}

	function convertUTCToLocalDate(date) {
		if (!date) {
			return date
		}
		date = new Date(date)
		date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
		return date
	}
	function getStartDate(lastDatePreviousMonth,months) {
		let date = new Date(lastDatePreviousMonth.getFullYear(), lastDatePreviousMonth.getMonth() - months, 1);
		return date;
	}
	const buildLink = (lastDatePreviousMonth) => {
		let startDateFinal = ''
		let endDateFinal = ''

		if (mode === "period") {
			switch (selectedPeriod) {
				case "lastmonth":
					startDateFinal = formatDate(getStartDate(lastDatePreviousMonth,0));
					break;
				case "threelastmonths":
					startDateFinal = formatDate(getStartDate(lastDatePreviousMonth,2));
					break;
				case "sixlastmonths":
					startDateFinal = formatDate(getStartDate(lastDatePreviousMonth,5));
					break;
				case "lastyear":
					startDateFinal = formatDate(getStartDate(lastDatePreviousMonth,11));
					break;
				default:
					return false; // In case selectedPeriod is undefined or not matched
			}
			endDateFinal = formatDate(lastDatePreviousMonth);
		} else {
			if (startDate && endDate) {
				startDateFinal = formatDate(new Date(startDate));
				const endOfPeriodTS = (new Date(endDate)).setHours(23, 59, 59, 999)
				endDateFinal = formatDate(new Date(endOfPeriodTS));
			} else {
				return false; // Handle cases where dates might not be set in other modes
			}
		}
		return '?startDate=' + startDateFinal + '&endDate=' + endDateFinal + '&subAccountCode=' + subAccountCode + '&language=' + i18n.language;
	}

	let isValidDate = true;
	if(startDate !== null && endDate !== null){
		if(startDate > endDate && mode === "specific"){
			isValidDate = false;
		}
	}

	const dayOfMonth = TODAY.getDate();
	let lastDatePreviousMonth = null;
	if (dayOfMonth > 5) {
		lastDatePreviousMonth = new Date(TODAY.getFullYear(), TODAY.getMonth(), 0);
	}else{
		lastDatePreviousMonth = new Date(TODAY.getFullYear(), TODAY.getMonth() - 1, 0);
	}
	const lastDatePreviousMonthName = lastDatePreviousMonth.toLocaleString(i18n.language, { month: 'short' });
	const lastDatePreviousThreeMonths = new Date(lastDatePreviousMonth.getFullYear(), lastDatePreviousMonth.getMonth() - 1, 0).toLocaleString(i18n.language, { month: 'short' });
	const lastDatePreviousSixMonths = new Date(lastDatePreviousMonth.getFullYear(), lastDatePreviousMonth.getMonth() - 4, 0).toLocaleString(i18n.language, { month: 'short' });
	const lastDatePreviousYear = new Date(lastDatePreviousMonth.getFullYear(), lastDatePreviousMonth.getMonth() - 10, 0).toLocaleString(i18n.language, { month: 'short' });

	return <div className="pb-4">
		<div className="row pb-4">
			<div className="col-6">
				<div>
					<h3 className="headline headline--block mb-3">
						{subAccountName}
					</h3>
					<strong className="d-block">
						{`#${subAccountCode}`}
					</strong>
					<strong className="d-block">
						{representative}
					</strong>
					<p>{t('account.summary.details.cards_amount')}&nbsp;:&nbsp;<strong>{numberOfCards}</strong></p>
				</div>

			</div>
			{/*<div className="col-6 d-flex align-items-center justify-content-end">
				<div>
					<strong>{t('account.summary.details.updated')}</strong>
					<p>
						{lastUpdate ? (
							<DateFormated date={lastUpdate} withTime={true}/>) : ''}
					</p>
				</div>
			</div>*/}
		</div>
		<div>
			<strong>{t('account.cards.consumption_report.makeachoice')}</strong>
			<div className="">
				<ul className="list-of-radios mt-4">
					<li style={{opacity: mode === 'period' || mode === null ? '1' : '0.5'}}>
						<label className="mr-4">
							<input type="radio" name="consumption_report_choice" id={`consumption_report_choice_period`}
								   value={"period"} onChange={(event) => {
								event.target.checked = true;
								setMode('period')
							}
							}
							/>
							<strong className="ml-3">{t('account.cards.consumption_report.period')}</strong>
						</label>
						{mode === 'period' && <SelectWrapper className="selectWrapper--full">
							<select id="test" onChange={(e) => {
								let selectValue = e.target.value;
								setSelectedPeriod(selectValue);
							}}
									value={selectedPeriod}>
								<option disabled={true} value="">{t('account.cards.consumption_report.select')}</option>
								<option value="lastmonth">{t('account.cards.consumption_report.lastmonth')}&nbsp;({lastDatePreviousMonthName})</option>
								<option
									value="threelastmonths">{t('account.cards.consumption_report.threelastmonths')}
									&nbsp;({ lastDatePreviousThreeMonths + " "+ t('account.cards.consumption_report.to') + " " + lastDatePreviousMonthName})								</option>
								<option
									value="sixlastmonths">{t('account.cards.consumption_report.sixlastmonths')}
									&nbsp;({ lastDatePreviousSixMonths + " "+ t('account.cards.consumption_report.to') + " " + lastDatePreviousMonthName})
								</option>
								{<option value="lastyear">{t('account.cards.consumption_report.lastyear')}
									&nbsp;({ lastDatePreviousYear + " "+ t('account.cards.consumption_report.to') + " " + lastDatePreviousMonthName})
								</option>}
							</select>
						</SelectWrapper>}
					</li>
					<li style={{opacity: mode === 'specific' || mode === null ? '1' : '0.5'}}>
						<label>
							<input type="radio" name="consumption_report_choice"
								   id={`consumption_report_choice_specific`}
								   value={"specific"} onChange={(event) => {
								event.target.checked = true;
								setMode('specific')
							}
							}
							/>
							<strong className="ml-3">{t('account.cards.consumption_report.specific')}</strong>
						</label>
					</li>
				</ul>
				{mode === 'specific' && <div>
					<div
						className="datespicker flex flex-column flex-md-row flex-md-wrap align-items-stretch flex-grow-1">
                <span className="align-self-start align-self-md-center justify-self-center">
                    <strong>{t("docs.invoices.table.filter.by_date")}&nbsp;</strong>
                </span>
						<div
							className="flex flex-row justify-content-between justify-content-md-start form-row mr-md-2">
							<label htmlFor="from" className="align-self-center justify-self-center mr-2 mb-0">
								{t("docs.invoices.table.filter.from")}
							</label>
							<div className="d-flex flex-grow-1 align-self-center justify-self-center"
								 style={{maxHeight: "38px", position: "relative"}}>
								{<DatePicker
									autoComplete="off"
									popperPlacement="top-start"
									id="from" locale={(() => {
									if (i18n.language === "fr") {
										return (fr)
									}
								})()}
									onChange={(date) => setStartDate(convertLocalToUTCDate(date))}
									selected={convertUTCToLocalDate(startDate)}
									className="form-control w-100"
									maxDate={lastDatePreviousMonth}
								/>}
								<i className="far fa-calendar-alt" style={{
									position: "absolute",
									right: "14px",
									top: "12px",
									pointerEvents: "none"
								}}></i>
							</div>
						</div>
						<div className="flex flex-row justify-content-between justify-content-md-start form-row">
							<label htmlFor="to" className="align-self-center justify-self-center mr-2 mb-0">
								{t("docs.invoices.table.filter.to")}
							</label>
							<div className="d-flex flex-grow-1 align-self-center justify-self-center"
								 style={{maxHeight: "38px", position: "relative"}}>
								{<DatePicker
									autoComplete="off"
									popperPlacement="top-start"
									id="to" locale={(() => {
									if (i18n.language === "fr") {
										return (fr)
									}
								})()}
									onChange={(date) => setEndDate(convertLocalToUTCDate(date))}
									selected={convertUTCToLocalDate(endDate)}
									className="form-control w-100"
									maxDate={lastDatePreviousMonth}
								/>}
								<i className="far fa-calendar-alt" style={{
									position: "absolute",
									right: "14px",
									top: "12px",
									pointerEvents: "none"
								}}></i>
							</div>
						</div>
					</div>
				</div>}
			</div>
		</div>
		{!isValidDate && <p className="p p--c-red mt-3">
			{t('account.cards.consumption_report.invalid_date')}
		</p>}
		<div className="d-flex justify-content-end mt-4">
			<div className="mr-3">
				<button className="btn btn--outline btn--outline--black" onClick={() => props.closeModal()}>
					{t('account.cards.consumption_report.cancel')}
				</button>
			</div>
			<div>
				<DownloadButton
					disabled={!isValidDate || mode === null || ((mode === 'period' && selectedPeriod === '') || (mode === 'specific' && (startDate === null || endDate === null)))}
					link={`/rest/v1/generate-consumption-report-pdf/${buildLink(lastDatePreviousMonth)}`}
					closeModal={props.closeModal}
					showDownloadIcon={true}
					showSpinner={true}
				>
					{t('account.cards.consumption_report.download')}
				</DownloadButton>
			</div>
		</div>
	</div>
}
export default ModalConsumptionReport;

